import { render, staticRenderFns } from "./fabric-editor.vue?vue&type=template&id=2515d57c"
import script from "./fabric-editor.vue?vue&type=script&lang=js"
export * from "./fabric-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports